import { Component, OnInit } from '@angular/core';
import { Widget } from 'src/app/shared/classes/Widget';
import { WidgetInjectedData } from 'src/app/shared/classes/WidgetInjectedData';
import { IconType } from 'src/app/shared/enums/IconType';
import { ITableGeneratorInput } from 'src/app/shared/interfaces/table-generator/ITableGeneratorInput';

@Component({
    selector: 'app-login-metrics',
    templateUrl: './login-metrics.component.html',
    styleUrls: ['./login-metrics.component.sass']
})
export class LoginMetricsComponent implements OnInit {
    widgetRef: Widget = null;
    tableInput: ITableGeneratorInput = null;

    constructor(widgetData: WidgetInjectedData) {
        this.widgetRef = widgetData.widgetRef;
    }
    ngOnInit(): void {
        this.tableInput = {
            afterResponse: null,
            widgetIconData: {
                type: IconType.SVG,
                class: 'metrics'
            },
            listExtraction: {
                type: 'DIRECT'
            },
            columns: [
                {
                    columnName: 'User Name',
                    columnKey: 'userName'
                },
                {
                    columnName: 'Customer Name',
                    columnKey: 'customerName'
                },
                {
                    columnName: 'Email ID',
                    columnKey: 'emailId'
                },
                {
                    columnName: 'Login Date & Time',
                    columnKey: 'loginDate'
                },
                {
                    columnName: 'Customer Domain',
                    columnKey: 'customerDomain'
                },
                {
                    columnName: 'SSO Configuration Name',
                    columnKey: 'ssoId'
                }
            ],
            selection: 'single'
        };
    }
}
